import { ApiUrl, Call, ParseDataResponse } from '@api/ApiUtils';
import { CreateEventSeriesParams, EventSeries } from 'types/EventSeries';
import { ID } from 'types/ID';

type ApiResponse<T> = Promise<{ data: T; success: boolean }>;

export function createEventSeries (params: CreateEventSeriesParams): ApiResponse<EventSeries> {
  return Call('post', ApiUrl('/event_series'), { event_series: params }, ParseDataResponse) as ApiResponse<EventSeries>;
}

export function getEventSeries (id: ID): ApiResponse<EventSeries> {
  return Call('get', ApiUrl(`/event_series/${encodeURIComponent(String(id))}`), {}, ParseDataResponse) as ApiResponse<EventSeries>;
}

export function getEventSeriesByBidRequest (bidRequestId: ID): ApiResponse<EventSeries> {
  return Call(
    'get',
    ApiUrl(`/event_series/by_bid_request?bid_request_id=${encodeURIComponent(String(bidRequestId))}`),
    {},
    ParseDataResponse
  ) as ApiResponse<EventSeries>;
}

/** Discontinues a series. Idempotent — re-terminating keeps the original timestamp. */
export function terminateEventSeries (id: ID): ApiResponse<EventSeries> {
  return Call(
    'post',
    ApiUrl(`/event_series/${encodeURIComponent(String(id))}/terminate`),
    {},
    ParseDataResponse
  ) as ApiResponse<EventSeries>;
}
